import React from 'react';
import MainLayout from '../layouts/MainLayout';
import ServicesGrid from '../components/ServicesGrid';
import { pageMeta } from '../lib/seo';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import { ArrowRight } from 'lucide-react';

const ServicesPage = () => {
  return (
    <MainLayout
      title={pageMeta.services.title}
      description={pageMeta.services.description}
      keywords={pageMeta.services.keywords}
    >
      {/* Page Header */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24 pb-8 bg-gradient-to-b from-primary-skin/30 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-text-dark mb-6">
            Unsere Leistungen
          </h1>
          <p className="text-lg md:text-xl text-primary-text-muted leading-relaxed">
            Entdecken Sie unser umfassendes Portfolio an professionellen Personal-
            und Logistikdienstleistungen. Maßgeschneiderte Lösungen für Ihre Branche.
          </p>
        </div>
      </section>

      {/* Services Grid with Filters */}
      <div className="w-full bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16 md:pb-24">
          <ServicesGrid />
        </div>
      </div>

      {/* CTA Section */}
      <section className="w-full bg-white pt-8 md:pt-12 pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center bg-white rounded-2xl p-8 md:p-12 shadow-soft border border-primary-gray-border">
            <h2 className="text-2xl md:text-3xl font-bold text-primary-text-dark mb-4">
              Ihre Anforderung nicht dabei?
            </h2>
            <p className="text-primary-text-muted mb-6">
              Wir bieten individuelle Lösungen für Ihre speziellen Anforderungen.
              Kontaktieren Sie uns für eine persönliche Beratung.
            </p>
            <Link to="/kontakt">
              <Button variant="primary" size="lg" icon={ArrowRight} iconPosition="right">
                Individuelle Anfrage stellen
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default ServicesPage;
